<div *ngIf="isBrowser" class="main-wrapper">
  <app-navbar></app-navbar>
  <!-- partial:sidebar -->
  <!-- <app-sidebar></app-sidebar> -->
  <!-- partial -->

  <div class="page-wrapper">
    <!-- partial:navbar -->
    <!-- partial -->

    <div class="page-content">
      <!-- Spinner for lazyload modules -->
      <div *ngIf="isLoading" class="spinner-wrapper">
        <div class="spinner">Loading...</div>
      </div>

      <div contentAnimate *ngIf="!isLoading">
        <router-outlet></router-outlet>
      </div>
    </div>

    <!-- partial:footer -->
    @if(!sharedDataService.user()){
    <app-footer></app-footer>
    }
    <!-- partial -->
  </div>
</div>
<ngx-ui-loader
[hasProgressBar]="false"
[fgsColor]="'#fb8f3f'"
></ngx-ui-loader>